import { gql } from 'graphql-request';

const GET_POSTS_QUERY = gql`
    query GetBlogPosts($tags: [String], $limit: Int, $offset: Int) {
        posts: resources(type: "blog", tags: $tags, limit: $limit, offset: $offset, order: DESC) {
            content
        }
    }
`;

const GET_POSTS_QUERY_WITH_TYPE_FILTER = gql`
    query GetBlogPosts($type: [String], $tags: [String], $limit: Int, $offset: Int) {
        posts: resources(type: $type, tags: $tags, limit: $limit, offset: $offset, order: DESC) {
            content
        }
    }
`;

export { GET_POSTS_QUERY, GET_POSTS_QUERY_WITH_TYPE_FILTER };
